import { updateQuestion } from '../../../reducers/questions'

export interface QuestionOption { id: string; value: string }
export interface QuestionLike {
  id: string
  question: string
  type: string
  isRequired: boolean
  options?: QuestionOption[]
  correctAnswers?: string[]
  minCorrectOptions?: number
  errors?: {
    questionText?: boolean
    optionErrors?: Record<string, boolean>
    correctAnswers?: boolean
    minSelection?: boolean
  }
}

export const deriveQuestionErrors = (q: QuestionLike): NonNullable<QuestionLike['errors']> => {
  const errors: NonNullable<QuestionLike['errors']> = { ...(q.errors || {}) }
  const isEmpty = (v?: string) => !v || v.trim() === ''

  errors.questionText = isEmpty(q.question)

  if (q.type === 'multiple_choice') {
    const optionErrors: Record<string, boolean> = { ...(q.errors?.optionErrors || {}) }
    const options = Array.isArray(q.options) ? q.options : []
    options.forEach(opt => {
      optionErrors[opt.id] = isEmpty(opt.value)
    })
    errors.optionErrors = optionErrors

    const correct = Array.isArray(q.correctAnswers) ? q.correctAnswers : []
    errors.correctAnswers = correct.length === 0

    if (correct.length > 0) {
      const minSel = q.minCorrectOptions
      const tooLow = !minSel || minSel < 1
      const tooHighByCorrect = !!minSel && minSel > correct.length
      errors.minSelection = tooLow || tooHighByCorrect
    } else {
      errors.minSelection = false
    }
  }

  return errors
}

export const hasAnyErrorFlag = (q: QuestionLike): boolean => {
  const e = q.errors || {}
  if (e.questionText) return true
  if (e.correctAnswers) return true
  if (e.minSelection) return true
  if (e.optionErrors && Object.values(e.optionErrors).some(Boolean)) return true
  return false
}

export const validateAndFlagQuestion = (q: QuestionLike, sectionId: string, dispatch: any): { isValid: boolean } => {
  const nextErrors = deriveQuestionErrors(q)
  const nextQuestion = { ...q, errors: nextErrors }
  const isValid = !hasAnyErrorFlag(nextQuestion)
  dispatch(updateQuestion(nextQuestion as any, sectionId))
  return { isValid }
}

export const validateSectionAndFlag = (
  sectionQuestions: QuestionLike[],
  sectionId: string,
  dispatch: any,
): boolean => {
  let allValid = true
  sectionQuestions.forEach(q => {
    const { isValid } = validateAndFlagQuestion(q, sectionId, dispatch)
    if (!isValid) allValid = false
  })
  return allValid
}

export const sectionHasErrors = (sectionQuestions: QuestionLike[]): boolean => {
  // Consider a section with no questions as invalid
  if (!sectionQuestions || sectionQuestions.length === 0) return true
  return sectionQuestions.some(q => {
    if (q.errors) return hasAnyErrorFlag(q)
    // const errs = deriveQuestionErrors(q)
    // return (
    //   errs.questionText ||
    //   errs.correctAnswers ||
    //   errs.minSelection ||
    //   (errs.optionErrors && Object.values(errs.optionErrors).some(Boolean))
    // )
  })
}

export const validateAllQuestionsAndFlag = (
  questionsBySection: Record<string, QuestionLike[]>,
  dispatch: any,
): boolean => {
  let allValid = true
  Object.keys(questionsBySection).forEach(sectionId => {
    const qs = questionsBySection[sectionId] || []
    if (!validateSectionAndFlag(qs, sectionId, dispatch)) allValid = false
  })
  return allValid
}

export const allQuestionsValidQuickCheck = (questionsBySection: Record<string, QuestionLike[]>): boolean => {
  const sections = Object.keys(questionsBySection)
  if (sections.length === 0) return false
  for (const sectionId of sections) {
    const qs = questionsBySection[sectionId] || []
    if (qs.length === 0) return false
    for (const q of qs) {
      const derived = deriveQuestionErrors(q)
      const anyErr =
        derived.questionText ||
        derived.correctAnswers ||
        derived.minSelection ||
        (derived.optionErrors && Object.values(derived.optionErrors).some(Boolean))
      if (anyErr) return false
    }
  }
  return true
}
